/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useStyles } from "../styles";

import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "../../../../../components/Button/Button";

export interface ButtonsProps {
  isPrimaryBtnDisabled: boolean;
  primaryBtnTitle: string;
  isWhite?: boolean;
  isLoadingPrimary?: boolean;
  isLoadingSecondary?: boolean;
  secondaryBtnTitle?: string;
  onSecondaryBtnClick?: () => void;
}

const Buttons = ({
  isPrimaryBtnDisabled,
  primaryBtnTitle,
  isWhite,
  isLoadingPrimary,
  isLoadingSecondary,
  secondaryBtnTitle,
  onSecondaryBtnClick,
}: ButtonsProps) => {
  const { authSetupActions } = useStyles();

  return (
    <div css={css(authSetupActions)}>
      {secondaryBtnTitle && (
        <Button
          fullWidth={!isWhite}
          variant={BUTTON_VARIANTS.TextOnly}
          size={BUTTON_SIZES.Normal}
          color={isWhite ? BUTTON_COLORS.White : BUTTON_COLORS.Secondary}
          isLoading={isLoadingSecondary || false}
          onClick={onSecondaryBtnClick}
        >
          {secondaryBtnTitle}
        </Button>
      )}

      <Button
        data-testid="submit-button"
        type="submit"
        fullWidth={!isWhite}
        variant={BUTTON_VARIANTS.TextOnly}
        size={BUTTON_SIZES.Normal}
        color={BUTTON_COLORS.Primary}
        isLoading={isLoadingPrimary || false}
        disabled={isPrimaryBtnDisabled}
      >
        {primaryBtnTitle}
      </Button>
    </div>
  );
};

export { Buttons };
